import gql from 'graphql-tag'

export const DELETE = gql`
  mutation product_fulfillable_delete($id: ID!) {
    productFulfillableDelete(id: $id) {
      id
    }
  }
`
